import { render, staticRenderFns } from "./RestorePasswordForm.vue?vue&type=template&id=46fcb3bc&scoped=true&"
import script from "./RestorePasswordForm.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcb3bc",
  null
  
)

export default component.exports